import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';
import { controlFocus } from '../primitives/shared.js';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Marks the current page in a navigation set — PRM-02 active state. */
  current?: boolean;
  children: ReactNode;
}

/**
 * PRM-02 Link. Navigates; never triggers an action, and a button is never
 * styled as a link. Visited state is not conveyed by colour alone (07-11).
 */
export function Link({ current, className, children, ...props }: LinkProps) {
  const disabled = props['aria-disabled'] === true || props['aria-disabled'] === 'true';

  return (
    <a
      data-primitive="PRM-02"
      aria-current={current ? 'page' : undefined}
      className={cn(
        'text-link font-medium underline-offset-2',
        'hov:underline',
        controlFocus,
        'active:text-primary-active',
        current && 'underline decoration-2',
        disabled && 'cursor-not-allowed text-disabled no-underline',
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
}
